export default class ClientUserListController {
    constructor($scope, $routeParams, userService, clientService, globalConstants) {
        this.scope = $scope;
        this.globalConstants = globalConstants;
        this.scope.displayAllTrainees = false;
        this.scope.traineesListLimit = 10;
        this.scope.traineesLength = 0;

        userService.getByClientId({ userType: 16, clientId: $routeParams.id }).then(resp => {
            this.users = resp.data;
            this.scope.traineesLength = this.users.length;
        });

        clientService.get($routeParams.id).then(resp => {
            this.client = resp.data;
        });
    }

    showAllTrainees() {
        this.scope.displayAllTrainees = true;
    }
}


// WEBPACK FOOTER //
// ./src/js/components/clients/clients.user-list.controller.js